export const M2C_HALFCARD_FREQUENCY_CAPPING_KEY = "food-m2c-halfcard-frequency-capping-key";
export const M2C_HALFCARD_GRATIFICATION_FREQUENCY_CAPPING_KEY = "food-m2c-halfcard-gratification-frequency-capping-key";

export const M2C_HALFCARD_MOUNT_DELAY = 0;

export const SWIGGY_ONE_CONFETTI = "APPLY_SWIGGY_ONE";

export const m2cCardCommsContainerId = "m2c-card-comms-container";
